export default __webpack_public_path__ + "static/media/icongrogue.d1c39bc8.png";